export default __webpack_public_path__ + "static/media/acct-user-payroll.d26720a5.png";